import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=0d2e3fb3&"
import script from "./EmptyLayout.vue?vue&type=script&lang=js&"
export * from "./EmptyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports